module.exports = __webpack_public_path__ + "b9012742776fcca030d16c248948788f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/materialdesignicons-webfont.svg?v=2.0.46
// module id = 599
// module chunks = 0